import { render, staticRenderFns } from "./playerDailyDetailSnapshot.vue?vue&type=template&id=f1f558c0&"
import script from "./playerDailyDetailSnapshot.vue?vue&type=script&lang=js&"
export * from "./playerDailyDetailSnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f558c0')) {
      api.createRecord('f1f558c0', component.options)
    } else {
      api.reload('f1f558c0', component.options)
    }
    module.hot.accept("./playerDailyDetailSnapshot.vue?vue&type=template&id=f1f558c0&", function () {
      api.rerender('f1f558c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/playerDailyDetailSnapshot.vue"
export default component.exports